import { Alert, Heading, Paragraph } from "@digdir/designsystemet-react";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { httpClient } from "@/api/client";
import { getAvtalePrivatOptions } from "@/api/generated/@tanstack/react-query.gen";
import { Page } from "@/components";
import { BekreftelseAvtaleDetaljerPrivat } from "./BekreftelseAvtaleDetaljerPrivat";
import { BekreftelseAvtaleIkkeAktiv } from "./BekreftelseAvtaleIkkeAktiv";
import { BekreftelseHeader } from "./BekreftelseHeader";
import { BekreftelseInformasjon } from "./BekreftelseInformasjon";
import { BekreftelseSkeleton } from "./BekreftelseSkeleton";
import { BekreftelseToForside } from "./BekreftelseToForside";

export const BekreftPrivatPage = () => {
  const { t } = useTranslation();

  const params = useParams({
    from: "/_app/avtaler/$avtalerId/privat/bekreftelse/",
  });

  const {
    data: avtale,
    isLoading,
    isError,
  } = useQuery({
    ...getAvtalePrivatOptions({
      client: httpClient,
      path: {
        id: params.avtalerId,
      },
    }),
  });

  const avtaleIsActive = avtale?.avtale.avtaleStatus === "Aktiv";
  const displayDetails = !isLoading && !isError;

  return (
    <Page withBackLink>
      <section className="max-w-2xl pt-6">
        {isLoading && <BekreftelseSkeleton />}
        {isError && (
          <Alert data-color="danger">
            <Heading data-size="xs">{t("skjema.feil-ved-henting")}</Heading>
            <Paragraph>{t("pages.bekreftelse.feil.hent")}</Paragraph>
          </Alert>
        )}
        {displayDetails && avtaleIsActive && (
          <>
            <BekreftelseHeader />
            <div className="flex flex-col my-8">
              <BekreftelseAvtaleDetaljerPrivat privatAvtale={avtale} />
              <BekreftelseInformasjon />
              <div className="mt-8">
                <BekreftelseToForside />
              </div>
            </div>
          </>
        )}
        {displayDetails && !avtaleIsActive && (
          <BekreftelseAvtaleIkkeAktiv
            avtaleStatus={avtale?.avtale.avtaleStatus}
            periodeFra={avtale?.avtale.activeFromInclusive}
            periodeTil={avtale?.avtale.activeToExclusive}
          />
        )}
      </section>
    </Page>
  );
};
